var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.profile.title'))+" ")]),_c('app-form',{attrs:{"form":_vm.form}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }